var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlag = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1896_1867",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "inherit"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1896_1867)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.39987 8.64623V13.6334C4.39987 13.7528 4.35748 13.8549 4.2727 13.9396C4.18793 14.0243 4.08581 14.0667 3.96637 14.0667C3.84681 14.0667 3.74476 14.0243 3.6602 13.9396C3.57554 13.8549 3.5332 13.7528 3.5332 13.6334V3.2694C3.5332 3.12084 3.58543 2.9944 3.68987 2.89007C3.7942 2.78562 3.92065 2.7334 4.0692 2.7334H11.8409C11.9503 2.7334 12.0461 2.76151 12.1282 2.81773C12.2104 2.87384 12.2773 2.9424 12.3289 3.0234C12.3804 3.1044 12.4013 3.19451 12.3915 3.29373C12.3816 3.39284 12.3484 3.4884 12.2917 3.5804L10.8345 5.6899L12.2917 7.79923C12.3484 7.89123 12.3816 7.98679 12.3915 8.0859C12.4013 8.18512 12.3804 8.27523 12.3289 8.35623C12.2773 8.43723 12.2104 8.50579 12.1282 8.5619C12.0461 8.61812 11.9503 8.64623 11.8409 8.64623H4.39987ZM4.39987 7.77957H11.155L10.1832 6.3104C10.0568 6.1254 9.99354 5.91845 9.99354 5.68957C9.99354 5.46068 10.0568 5.2539 10.1832 5.06923L11.155 3.60007H4.39987V7.77957Z",
  fill: "#2400FF"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flag.ad95edac059dd258cdff8175919b8b44.svg";